export enum MissionAdvancementPossibilities {
  SUBMITTED = 1,
  REFUSED_DC = 2,
  RESERVE_DC = 3,
  ACCEPTATION_DC = 4,
  REFUSED_CLIENT = 5,
  RESERVE_CLIENT = 6,
  ACCEPTATION_CLIENT = 7,
}
